import ImageConverter from "../../utils/convert/ImageConverter";
import { ImageDTOApi } from "./ImageDTO";
import { NewsItemImageResponseApi } from "../ServerResponseType/News/NewsItemImage";

export default class NewsImageDTO implements ImageDTOApi {
  private _imageData?: NewsItemImageResponseApi;

  constructor(imageData?: NewsItemImageResponseApi) {
    this._imageData = imageData;
  }

  get imageId(): string {
    return this._imageData ? this._imageData.newsImageId : "1";
  }

  get imageData(): string | File | undefined {
    return this._imageData?.image;
  }

  get imageSrc(): string {
    return this._imageData
      ? ImageConverter.AddConfigStringBeforeImageDataString(
          this._imageData.image,
          "image/png"
        )
      : "/img/kotobot_img_not_exists.jpeg";
  }
}
